import { render, staticRenderFns } from "./FormFideicomiso.vue?vue&type=template&id=28450825"
import script from "./FormFideicomiso.vue?vue&type=script&lang=js"
export * from "./FormFideicomiso.vue?vue&type=script&lang=js"
import style0 from "./FormFideicomiso.vue?vue&type=style&index=0&id=28450825&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28450825')) {
      api.createRecord('28450825', component.options)
    } else {
      api.reload('28450825', component.options)
    }
    module.hot.accept("./FormFideicomiso.vue?vue&type=template&id=28450825", function () {
      api.rerender('28450825', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/comparecientes/FormFideicomiso.vue"
export default component.exports